import React, { useEffect } from "react";
import "./home-page.styles.scss";
import Links from "../../components/links/Links";
import RecentMV from "../../components/recent-mobile-view/RecentMV";
import Recentcs from "../../components/recent/Recentcs";
import Slideshow from "../../components/slideshow/Slideshow";
import { Link } from "react-router-dom";

export const HomePage = () => {
  useEffect(() => {
    localStorage.removeItem("selectedSection");
  }, []);
  return (
    <div>
      <div className="home">
        <Slideshow />
        <Recentcs class="x" name={"Just Dropped"} tag={"Just Dropped"} />
        <Recentcs name={"Most Popular"} tag={"Most Popular"} />
        <Recentcs name={"Favorites"} tag={"Favourites"} />
        <Recentcs name={"Air Jordon"} tag={"Air Jordan"} />
        <Recentcs name={"Adidas Yeezy"} tag={"Adidas Yeezy"} />
        <Recentcs name={"Dunks"} tag={"Dunks"} />
        <Recentcs name={"Jordon 1"} tag={"Jordan 1"} />
        <Recentcs name={"Travis Scot"} tag={"Travis Scott"} />
        <Recentcs name={"Off White"} tag={"Off-White"} />
        <Links />
      </div>

      <div className="home-mob">
        <Slideshow />
        <RecentMV class="x" name={"Just Dropped"} tag={"Just Dropped"} />
        <RecentMV name={"Most Popular"} tag={"Most Popular"} />
        <RecentMV name={"Favorites"} tag={"Favourites"} />
        <RecentMV name={"Air Jordon"} tag={"Air Jordan"} />
        <RecentMV name={"Adidas Yeezy"} tag={"Adidas Yeezy"} />
        <RecentMV name={"Dunks"} tag={"Dunks"} />
        <RecentMV name={"Jordon 1"} tag={"Jordan 1"} />
        <RecentMV name={"Travis Scot"} tag={"Travis Scott"} />
        <RecentMV name={"Off White"} tag={"Off-White"} />
        <Links />
      </div>
    </div>
  );
};
